module.exports = __webpack_public_path__ + "img/shopping_banner03.21b214a4.png";